import {getQueryParams, getUrlVarFromWindow} from '../utils/helpers';

'use strict';
const _ = require('lodash');

let guestId = getUrlVarFromWindow('guestId');
let entityCode = getUrlVarFromWindow('entityCode');

const initialState = {
  page: window.pageName,
  email: '',
  legalCountry: 'none',
  location: window.loc,
  countryBloc: 'none',
  name: '',
  guestId: (_.isUndefined(guestId) ? '' : encodeURIComponent(guestId)),
  entityCode: (_.isUndefined(entityCode) ? '' : entityCode),
  langPref: window.langPref,
  queryParams: getQueryParams(),
  hasClickbackSuccess: false,
  hasClickbackFailure: false
};

module.exports = (state = initialState, action) => {
  switch (action.type) {
    case 'RECEIVE_EMAIL':
      return {
        ...state,
        email: action.email
      };
    case 'RECEIVE_LEGALCOUNTRY':
      return {
        ...state,
        legalCountry: action.legalCountry
      };
    case 'RECEIVE_COUNTRYBLOC':
      return {
        ...state,
        countryBloc: action.countryBloc
      };
    case 'RECEIVE_NAME':
      return {
        ...state,
        name: action.name
      };
    case 'RECEIVE_GUESTID':
      return {
        ...state,
        guestId: action.guestId
      };
    case 'CLICKBACK_SUCCESS':
      return {
        ...state,
        hasClickbackSuccess: true,
        hasClickbackFailure: false
      };
    case 'CLICKBACK_FAILURE':
      return {
        ...state,
        hasClickbackSuccess: false,
        hasClickbackFailure: true
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./client/src/reducers/app.js